(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-cust"] && !Shopify.designMode) return;
  try {
    window.initProductMediaGallery = function() {
  const intervalId = setInterval(() => {
    const mainSwiperContainer = document.querySelector('.main-swiper');
    const thumbList = document.querySelector('.thumb-list');
    const thumbSwiper = document.querySelector('.thumb-swiper');
    const withHover = document.querySelector('.with-hover');
    
  
    if (mainSwiperContainer) {
      let thumbsSwiper;
  
      if (thumbList) {
        // Use .thumb-list with slidesPerView: 'auto'
        thumbsSwiper = new Swiper('.thumb-list', {
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesProgress: true,
        });
      } else if (thumbSwiper) {
        // Use .thumb-swiper with fixed slidesPerView
        thumbsSwiper = new Swiper('.thumb-swiper', {
          direction: "vertical",
          spaceBetween: 10,
          slidesPerView: 6,
          freeMode: true,
          watchSlidesProgress: true,
          
          breakpoints: {
            1024: {
              slidesPerView: 8,
            },
            1290: {
              slidesPerView: 10,
            },
          },
        });
      }
      // Initialize main swiper with thumbs
      if (thumbsSwiper) {
        new Swiper('.main-swiper', {
          slidesPerView: 1.23,
          spaceBetween: 10,
          thumbs: {
            swiper: thumbsSwiper,
          },
          navigation: {
            nextEl: ".swiper-main-button-next",
            prevEl: ".swiper-main-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            type: "fraction"
          },
          breakpoints: {
            426: {
              slidesPerView: 2.23,
              centeredSlides: true,
            },
            768: {
              slidesPerView: 2.13,
              spaceBetween: 20,
              centeredSlides: true,
            },
            951: {
              spaceBetween: 0,
              slidesPerView: 1,
              cssMode: true,
              centeredSlides: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            },
          },
        });
        clearInterval(intervalId); // Stop checking once initialized
      }
    }
    
      if(withHover) {
        enableZoomOnHover(2);
      }
  }, 400); // Check every 100ms until swiper elements are available
}
document.addEventListener('DOMContentLoaded', window.initProductMediaGallery);
  } catch(e) { console.error(e); }
})();

})();
